import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './login.css';
import logo from '../../img/D2P-logo-show-login-sm.png';
import Globals from '../../config/globals';
import Axios from '../../config/axios';
import cookie from 'react-cookies';
//import TFASetup from "./TFASetup";
//import TFALogin from "./TFALogin";
import ReactLoading from 'react-loading';
import { toast, confirm } from '@rickylandino/react-messages';
import { Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import ForgotPassword from './ForgotPassword';
import ContactForm from './ContactForm';

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            validUserFound: true,
            mode: "noShowTwoFactor",
            formFields: {
                userid: '',
                password: ''
            },
            showToast: false,
            toastContent: {
                title: '',
                content: ''
            },
            loading: false,
            showSelectModal: false,
            locationList: []
        }

        Globals.userInfo = {};
        Globals.enrolledShows = [];

        window.sessionStorage.setItem("userInfo", JSON.stringify(Globals.userInfo));
        window.sessionStorage.setItem("enrolledShows", JSON.stringify(Globals.enrolledShows));
    }

    goLogin = () => {
        this.setState({
            mode: "noShowTwoFactor",
        });
    }

    toggleToast = (toastContent) => {
        if (toastContent) {
            this.setState({
                showToast: !this.state.showToast,
                toastContent
            });
        } else {
            this.setState({
                showToast: !this.state.showToast
            });
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } });
    }

    handleSubmit = async (event) => {
        event.preventDefault();

        const userid = this.state.formFields.userid?.trim();
        const password = this.state.formFields.password?.trim();

        if (!userid) {
            document.getElementById("userid").focus();
            return;
        }

        if (!password) {
            document.getElementById("password").focus();
            return;
        }

        this.setState({ loading: true });

        try {
            const response = await Axios.post(`/api/login`, {
                userId: userid,
                password: password
            });

            const commandresult = response.data;

            const userInfo = commandresult.userInfo;

            Globals.userInfo = userInfo;
            Globals.enrolledShows = commandresult.enrolledShows || [];
            Globals.adminMode = commandresult.adminMode || "";
            Globals.isImpersonating = false;

            window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
            window.sessionStorage.setItem("enrolledShows", JSON.stringify(Globals.enrolledShows));
            window.sessionStorage.setItem("adminMode", Globals.adminMode);
            window.sessionStorage.setItem("isImpersonating", "");

            if (userInfo.isAdmin) {
                Globals.realUserInfo = userInfo;
                window.sessionStorage.setItem("realUserInfo", JSON.stringify(userInfo));
            }

            Globals.token = commandresult.token;
            sessionStorage.setItem("token", commandresult.token);

            Axios.defaults.headers.common["Authorization"] =
                `Bearer ${commandresult.token}`;

            let path = commandresult.redirectPath || "/exhibitor-home";

            if (Globals.pathname && Globals.pathname !== "/" && path === "/exhibitor-home") {
                path = Globals.pathname;
            }

            this.props.history.replace(path);
        }
        catch (error) {
            toast.error('Invalid User Credentials.');

            this.setState({
                formFields: {
                    userid: '',
                    password: ''
                },
                loading: false
            });
        }
    }

    validateUser = async () => {
        let commandresult = "";

        let postdata = {};
        postdata.userid = this.state.formFields.userid;
        postdata.password = this.state.formFields.password;

        await Axios.post(`/api/token`, postdata
        ).then(response => {    
            commandresult = response.data;

            let userInfo = { ...Globals.userInfo };
            userInfo.bearer = commandresult.token;
            userInfo.userId = commandresult.userID;
            userInfo.username = commandresult.username;
            userInfo.fullName = commandresult.fName + " " + commandresult.lName;
            userInfo.isLoggedIn = true;
            Globals.userInfo = userInfo;

            let pdata = {
                uniqueID: commandresult.userID
            }
        }).catch(error => {
            console.log(error);
        });
    }

    forgotPasswordClick = () => {
        this.setState({
            mode: 'forgotPassword'
        });
    }

    goHome = () => {
        this.setState({
            mode: 'noShowTwoFactor'
        });
    }

    contactUsClick = () => {
        this.setState({
            mode: 'contactUs'
        });
    }

    render() {

        const columns = [{
            dataField: 'customer.street1',
            text: 'Address'
        }, {
            dataField: 'customer.city',
            text: 'City'
        }, {
            dataField: 'customer.state',
            text: 'State'
        }];

        const selectRow = {
            mode: 'radio',
            clickToSelect: true,
            hideSelectColumn: true
        };

        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                // set limited scope bearer token where Axios knows where to find it
                let userInfo = Globals.userInfo;
                userInfo.bearer = row.token;
                userInfo.customerInfo = row.customer;
                userInfo.companyId = row.contact.company_id;
                userInfo.companyName = row.customer.name;

                Globals.userInfo = userInfo;
                window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));

                Axios.get(`/api/GetEnrolledShowsByCompanyId`, {
                    params: {
                        id: userInfo.companyId.toString()
                    }
                }).then(response => {
                    let enrolledShows = Globals.enrolledShows;

                    enrolledShows = response.data;

                    Globals.enrolledShows = enrolledShows;
                    window.sessionStorage.setItem("enrolledShows", JSON.stringify(enrolledShows));

                    let path = '/exhibitor-home';
                    this.props.history.replace(path);
                }).catch(error => {
                    console.log(error);
                });
            }
        };

        return (
            <div className="background">
                <div className="blankpage-form-field">
                    <div className="page-logo m-0 w-100 align-items-center justify-content-center rounded border-bottom-left-radius-0 border-bottom-right-radius-0 px-4">
                        <img src={logo} height="30px" alt="Design-2-Part Shows My Show Online" aria-roledescription="logo" />
                        <div><div className="page-logo-text-header mr-1">MY SHOW ONLINE</div><div className="page-logo-text mr-1">Your D2P Customer Service Center</div></div>
                    </div>
                    <div className="card p-4 border-top-left-radius-0 border-top-right-radius-0">

                        {/*{this.state.mode === "showTwoFactor" &&*/}
                        {/*    <TFALogin validateUser={this.validateUser} goLogin={this.goLogin} userid={this.state.formFields.userid} password={this.state.formFields.password} />*/}
                        {/*}*/}
                        {/*{this.state.mode === "showTwoFactorSetUp" &&*/}
                        {/*    <TFASetup validateUser={this.validateUser} goLogin={this.goLogin} userid={this.state.formFields.userid} password={this.state.formFields.password} />*/}
                        {/*}*/}
                        {this.state.mode === "noShowTwoFactor" &&


                        <form>
                            <div className="form-group">
                                <label className="form-label" htmlFor="userid">Username</label>
                                <input type="text" id="userid" className="form-control-custom" name="userid" value={this.state.formFields.userid} onChange={this.handleInputChange} />
                                <span className="help-block">
                                    Your username
                                </span>
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="password">Password</label>
                                <input type="password" id="password" name="password" value={this.state.formFields.password} onChange={this.handleInputChange} className="form-control-custom" />
                                <span className="help-block">
                                    Your password
                                </span>
                            </div>
                            {this.state.loading &&
                                <ReactLoading className='tableLoading float-left' type={"spokes"} color={'#275282'} height={30} width={30} />
                            }
                            <button className="btn btn-default float-right" onClick={this.handleSubmit}>Login</button>
                        </form>
                        }

                        {this.state.mode === 'forgotPassword' &&
                            <ForgotPassword goHome={this.goHome} />
                        }

                        {this.state.mode === 'contactUs' &&
                            <ContactForm goHome={this.goHome} />
                        }

                    </div>

                    <div className="blankpage-footer text-center row">
                        {this.state.mode === 'forgotPassword' ?
                            <div className="myshowonlineTextA col-6 align-items-right a" onClick={this.goHome}><strong>Go Back To Login</strong></div>
                            :
                            <div className="myshowonlineTextA col-6 align-items-right a" onClick={this.forgotPasswordClick}><strong>Create/Reset Password</strong></div>
                        }

                        {this.state.mode === 'contactUs' ?
                            <div className="myshowonlineTextA col-6 align-items-right a" onClick={this.goHome}><strong>Go Back To Login</strong></div>
                            :
                            <div className="myshowonlineTextA col-6 align-items-left a" onClick={this.contactUsClick}><strong>Contact Us</strong></div>
                        }

                        &nbsp;&nbsp;&nbsp;
                    </div>
                    
                    {/*<div className="blankpage-footer text-center row">*/}
                    {/*    {this.state.mode === 'contactUs' ?*/}
                    {/*        <div className="myshowonlineTextA col-12 align-items-right a" onClick={this.goHome}><strong>Go Back To Login</strong></div>*/}
                    {/*        :*/}
                    {/*        <div className="myshowonlineTextA col-12 align-items-left a" onClick={this.contactUsClick}><strong>Contact Us</strong></div>*/}
                    {/*    }*/}
                    {/*</div>*/}

                </div>
                {this.state.locationList.length > 0 &&
                    <Modal size='lg' show={this.state.showSelectModal} onHide={() => this.setState({ showSelectModal: false })} backdrop='static' className="modal-popup">
                        <Modal.Header>
                            <i className="fas fa-exclamation-circle color-blue fa-15x mr-3"></i>
                        <Modal.Title>{this.state.locationList[0].customer.name}
                            <h4>Select A Location To Work With</h4>
                        </Modal.Title>
                            <a className="alignRight close" id="closeModal" onClick={() => this.setState({ showSelectModal: false })}>&times;</a>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="panel-content">
                            <BootstrapTable keyField='patientExamModel.patientExamID'
                                data={this.state.locationList}
                                columns={columns}
                                rowEvents={rowEvents}
                                selectRow={selectRow}
                                hover condensed striped />
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" onClick={() => this.setState({ showSelectModal: false })} className="btn btn-submit">
                                OK
                        </button>

                        </Modal.Footer>
                    </Modal>
                }
            </div>
        );
    }
}

export default withRouter(Login);
